// #region Imports

/* Telestream */
import {
  ATTACH_QUICKVIEW_ELEMENT,
  PAUSE_VIDEO,
  START_QUICKVIEW,
  STOP_QUICKVIEW
} from '@/utils/action-types';
import {
  SET_QUICKVIEW_CONTROLLER,
  SET_QUICKVIEW_ELEMENT,
  SET_QUICKVIEW_PATH,
  SET_QUICKVIEW_STATUS,
} from '@/utils/mutation-types';
import { generateBaseUrl, generateMasterManifestUrl } from './utilities/connection.utils';
import { fetchMediaProperties, generateController } from './utilities/media.utils';
import { LEVELS, sendEphemeralSnack } from './utilities/snacks.utils';

// #endregion Imports

export const quickview = {
  // #region State

  state: {
    element:    undefined,
    controller: undefined,
    path:       undefined,
    status:     'idle',
  },

  // #endregion State

  // #region Mutations

  mutations: {
    [SET_QUICKVIEW_CONTROLLER](state, controller) {
      state.controller = controller;
    },

    [SET_QUICKVIEW_ELEMENT](state, element) {
      state.element = element;
    },

    [SET_QUICKVIEW_PATH](state, path) {
      state.path = path;
    },

    [SET_QUICKVIEW_STATUS](state, status) {
      state.status = status;
    },
  },

  // #endregion Mutations

  // #region Actions

  actions: {
    [ATTACH_QUICKVIEW_ELEMENT](context, element) {
      context.commit(SET_QUICKVIEW_ELEMENT, element);
    },

    async [START_QUICKVIEW](context, path, open) {
      // Don't want to have the main video playing alongside the preview:
      context.dispatch(PAUSE_VIDEO);

      if (context.state.controller) {
        context.state.controller.destroy();
        context.commit(SET_QUICKVIEW_CONTROLLER, undefined);
      }

      context.commit(SET_QUICKVIEW_STATUS, 'loading');
      context.state.element.addEventListener(
        'canplay',
        () => {
          context.commit(SET_QUICKVIEW_STATUS, 'ready');
        },
        {
          once: true,
        }
      );
      const baseUrl = generateBaseUrl(path, [], 0, 0, undefined, context.state.element, open);

      let manifestUrl;
      try {
        manifestUrl = await generateMasterManifestUrl(baseUrl);
      }
      catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            const message = `User '${error.response.data.userName}' is not authorized to access '${error.response.data.path}'`;
            sendEphemeralSnack(context, LEVELS.ERROR, message);
          }
        }
        throw error;
      }

      const mediaProperties = await fetchMediaProperties(new URL(manifestUrl).origin, path, [], open);
      const quality = {
        currentLevel:     undefined,
        drawAlphaChannel: false,
      };

      const controller = generateController(context.state.element, manifestUrl, mediaProperties, quality);
      controller.init();
      context.commit(SET_QUICKVIEW_CONTROLLER, controller);

      context.commit(SET_QUICKVIEW_PATH, path);
    },

    [STOP_QUICKVIEW](context) {
      if (context.state.controller) {
        context.state.controller.destroy();
        context.commit(SET_QUICKVIEW_CONTROLLER, undefined);
        context.commit(SET_QUICKVIEW_PATH, undefined);
        context.commit(SET_QUICKVIEW_STATUS, 'idle');
      }
    },
  },

  // #endregion Actions
};
